interface FormCardProps {
  /** Form fields, inputs, and actions rendered inside the card. */
  children: React.ReactNode;
  title?: string;
}

/**
 * @component FormCard
 * @description Reusable form container atom used across authentication forms.
 * Renders a white card with a lime accent top border and silver side/bottom borders.
 * @param children - Form fields, inputs, and actions rendered inside the card.
 * @returns A styled card wrapping the provided form content.
 */
export default function FormCard({ children, title }: FormCardProps) {
  return (
    <div className="bg-white border-t-4 border-t-lime border-x border-b border-card-stroke flex flex-col gap-4 p-6 md:p-8">
      {title?.length ? <p className="text-title mb-4">{title}</p> : <></>}
      {children}
    </div>
  );
}
